/* Magnetik cart page.
   Quantity changes and removals go through Shopify's native /cart/change.js.
   The page reloads after each change so Liquid re-renders the real totals and
   discount allocations, rather than this file guessing at the maths. */
(function () {
  'use strict';

  var page = document.getElementById('cart-page');
  if (!page) return;

  var busy = false;

  function change(key, quantity) {
    if (busy) return;
    busy = true;
    page.style.opacity = '.55';
    page.style.pointerEvents = 'none';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root.replace(/\/$/, '') + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      })
      .then(function () {
        /* Re-put the right bundle code on the cart before the reload, so the
           page that comes back already shows the total Shopify will charge.
           Shopify validates the code's minimum itself, so dropping below a
           tier drops the discount with it. */
        if (window.MagnetikDrawer && window.MagnetikDrawer.syncBundleNow) {
          return window.MagnetikDrawer.syncBundleNow();
        }
      })
      .then(function () { window.location.reload(); })
      .catch(function () {
        busy = false;
        page.style.opacity = '';
        page.style.pointerEvents = '';
      });
  }

  page.addEventListener('click', function (e) {
    var t = e.target;

    var rm = t.closest && t.closest('.cart-remove');
    if (rm) { e.preventDefault(); change(rm.getAttribute('data-key'), 0); return; }

    var down = t.closest && t.closest('.qty-down');
    if (down) {
      e.preventDefault();
      var i1 = down.parentNode.querySelector('.qty-input');
      change(i1.getAttribute('data-key'), Math.max(0, parseInt(i1.value, 10) - 1));
      return;
    }

    var up = t.closest && t.closest('.qty-up');
    if (up) {
      e.preventDefault();
      var i2 = up.parentNode.querySelector('.qty-input');
      change(i2.getAttribute('data-key'), parseInt(i2.value, 10) + 1);
    }
  });

  /* ---------- bundle pricing stopgap ----------
     Add to cart now stays on the page, so the old add -> /discount -> /checkout
     hop is gone. Until automatic discounts exist in Admin, route the checkout
     button through /discount/{code} so the advertised bundle price is what the
     customer actually pays. Skips entirely once a discount is already applied
     (i.e. once automatic discounts are live) or once the codes are cleared. */
  var form = document.getElementById('cart-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (page.getAttribute('data-discounted') === 'true') return;   /* already discounted */

      var count = parseInt(page.getAttribute('data-count'), 10) || 0;
      var code = count >= 3 ? page.getAttribute('data-three-code')
               : count >= 2 ? page.getAttribute('data-two-code')
               : '';
      if (!code) return;                                            /* codes cleared, normal POST */

      e.preventDefault();
      window.location.href = '/discount/' + encodeURIComponent(code) +
                             '?redirect=' + encodeURIComponent('/checkout');
    });
  }

  /* ---------- keep the displayed total honest on load ----------
     Someone can reach /cart without ever passing through add-to-cart (a
     bookmark, a back button, a cart permalink), so put the tier's code on the
     cart and reload once to show the number checkout will charge.

     The reload is stamped in sessionStorage FIRST, keyed on the cart's line
     signature. If applying the code silently does nothing -- an expired code,
     a minimum that no longer matches, a discount already applied by other
     means -- this still runs at most once for that cart, so the page cannot
     loop no matter what the server says. Changing the cart changes the
     signature, which is exactly when a fresh attempt is wanted. */
  (function syncOnLoad() {
    if (!window.MagnetikDrawer || !window.MagnetikDrawer.syncBundleNow) return;

    var sig = 'mgk-bundle:' + (page.getAttribute('data-count') || '0') +
              ':' + (page.getAttribute('data-discounted') || 'false');

    try {
      if (sessionStorage.getItem(sig) === '1') return;
      sessionStorage.setItem(sig, '1');
    } catch (e) {
      return;   /* no sessionStorage (private mode) -> never risk a loop */
    }

    window.MagnetikDrawer.syncBundleNow().then(function (changed) {
      if (changed) window.location.reload();
    });
  })();

  /* typing a quantity directly */
  page.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('qty-input')) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    change(input.getAttribute('data-key'), q);
  });
})();
